<template>
   <div class="modal fade" id="searchAffiliate" tabindex="-1" aria-labelledby="searchAffiliateLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
         <div class="modal-content bg-light">
            <div class="modal-header row py-0">
               <h5 class="modal-title col-10" id="searchAffiliateLabel">Buscar Afiliados por </h5>
               <button type="button" class="btn-close btn-sm col-2 mx-0" 
                  ref="closeSearch" data-bs-dismiss="modal" aria-label="Close"></button>
               <div class="row">
                  <div class="col-12 container">
                     <div class="row justify-content-evenly">
                        <div v-for="(option, index) in configSearch.options" :key="index"
                           class="form-check col-auto">
                           <input class="form-check-input px-2" type="radio" name="flexRadioDefault" id="option.code"
                              @click=" selectedsearchOptions = option.code "
                              :checked="index == 0"
                              :disabled="showAllData"
                              >
                           <label class="form-check-label" for="option.code">
                              {{option.label}}
                           </label>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="modal-body">
               <!--
               {{dataFound}}
               <div class="table-responsive">
                     <thead class="bg-thead">
               -->
               <div v-if="showAllData" class="all-data p-3">
                  <affiliate-data 
                     :dataAffiliate="dataFound[showIndex]" 
                     class="mt-4 p-3 rounded border text-center aff-data"/>
                  <div class="pt-1 d-flex justify-content-end">
                     <button type="button" 
                           class="btn btn-outline-light me-1"
                           @click="sendAffil(dataFound[showIndex].id)"
                           >
                        Aceptar
                     </button>
                     <button type="button" 
                           class="btn btn-outline-light" 
                           @click="showAllData = false">
                        Salir
                     </button>
                  </div>
               </div>
               <table v-else class="table table-sm table-light table-striped table-borderless">
                  <thead class="table-dark">
                     <tr class="bg-thead">
                        <td>CUIL</td>
                        <td class="ws-nowrap">Apellido y Nombre</td>
                        <td colspan="2">Documento</td>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(item, index) in dataFound" :key="index" 
                           class="border-0" 
                           :class=" item.active ? '' : 'table-danger'"
                           @click="showThis(index)"
                           >
                        <td>{{item.id}}</td>
                        <td class="ws-nowrap">{{item.name}}</td>
                        <td>{{item.documentType}}</td>
                        <td>{{item.documentNumber}}</td>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div class="modal-footer d-flex justify-content-between pe-4">
               <div class="col-lg-8">
                  <div class="input-group">
                     <input ref="itSearch"
                           type="text" class="form-control"
                           v-model="inputSearch"  v-on:keyup.enter="searchAffiliate(true)"
                           :disabled="showAllData"
                     >
                     <button type="submit" class="btn btn-secondary" v-on:click="searchAffiliate(true)" :disabled="showAllData">
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                           </svg>
                     </button>
                  </div>
               </div>
               <nav aria-label="Page navigation example" class=" col-lg-3 pgnav">
                  <ul class="pagination text-muted d-flex">
                     <li class="page-item">
                        <button type="button" class="page-link text-muted" v-on:click="addItems()" :disabled="showAllData">
                           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-plus-lg mb-1" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                           </svg>
                        </button>
                     </li>
                     <!--
                     <li class="page-item disabled el-del-medio"><a class="page-link hgt-del-medio">{{itemsShow}}/{{totalItems}}</a></li>
                     -->
                     <li class="page-item disabled flex-grow-1 text-center"><a class="page-link hgt-del-medio">{{itemsShow}}/{{totalItems}}</a></li>
                     <li class="page-item">
                        <button type="button" class="page-link text-muted" v-on:click="reset()" :disabled="showAllData">
                           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-eraser mb-1" viewBox="0 0 16 16">
                              <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"/>
                           </svg>
                        </button>
                     </li>
                  </ul>
               </nav>
            </div>
         </div>
      </div>
   </div>
   <!--
   -->
</template>

<script>
import { ref, onMounted } from 'vue'
import AnalyService from "../../analytics.service";
import useEventsBus from '/src/services/eventBus';
//import WspService from "../workSpace.service";
//import { useStore } from 'vuex'
import AffiliateData from '/src/modules/analytics/components/affiliate/AffiliateDataShow.vue';
//src\modules\analytics\components\affiliate\AffiliateDataShow.vue

//import content_ from './ContentTableTypeList.vue';

export default {
   components: {
      AffiliateData
   },
   setup() {
      //const store = useStore()
      const boardId = ref(0)

      const dataFound = ref([])
      const inputSearch = ref('')
      const itSearch = ref(null)
      const itemsShow = ref(0)
      const totalItems = ref(0)

      const selectedsearchOptions = ref('TXT')

      //const configSearch = ref({"options":[{"code":"TXT","label":"por Nombre"},{"code":"NUM","label":"por Nro. de Documento"},{"code":"ID","label":"por CUIL"}]})
      const configSearch = ref({"options":[]})
      const {emiter} = useEventsBus()

      const showAllData = ref(false)
      const showIndex = ref(0)
      const closeSearch = ref(null)

      const addItems = () => {
         if (itemsShow.value < totalItems.value) {
            searchAffiliate(false)
         }
      }

      const reset = () => {
         dataFound.value = []
         inputSearch.value = ''
         itemsShow.value = 0
         totalItems.value = 0
         boardId.value = 0
         itSearch.value.focus()
      }

      const sendAffil = (cuil) => {
         emiter('cuil', cuil)
         reset()
         showIndex.value = 0
         showAllData.value = false
         closeSearch.value.click()
      }

      const showThis = (index) => {
         showIndex.value = index
         showAllData.value = true
      }

      const searchAffiliate = (start) => {
         if (start) {
            dataFound.value = []
            itemsShow.value = 0
         }
         
         AnalyService.findAffiliateAllData(
            10,                  // itemsByPage, 
            itemsShow.value,     //  start, 
            inputSearch.value,    // searchText
            selectedsearchOptions.value // searchOption
            )
         .then(response => {
            dataFound.value.push(...response.data.affiliateList)
            //dataFound.value = response.data
            totalItems.value = response.data.totalItems
            //console.log("searchAffiliate: " + response.data.contentList)
            itemsShow.value = dataFound.value.length
         })
         .catch(error => {
            console.log(error);
         });
         
      }

      onMounted(() => {
         document.getElementById('searchAffiliate')
         .addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget
            reset()
            console.log(button.getAttribute('data-search-config'))
            configSearch.value = JSON.parse(button.getAttribute('data-search-config'))
            //configSearch.value = button.getAttribute('data-search-config')
            //console.log(JSON.parse(JSON.stringify(configSearch.value)))
         })
         console.log("search affiliate modal")
      })

      return {
         addItems,
         closeSearch,
         configSearch,
         dataFound,
         inputSearch,
         itSearch,
         itemsShow,
         reset,
         searchAffiliate,
         selectedsearchOptions,
         sendAffil,
         showAllData,
         showIndex,
         showThis,
         totalItems
      };
   }
}
</script>

<style scoped>
.pgnav {
    height: 38px;
}
.modal-dialog-scrollable .modal-content {
    /*max-height: 100%;*/
    height: 100%;
    overflow: hidden;
}
.modal-header .btn-close {
    padding: .5rem .5rem;
    margin: -.5rem -.5rem -.5rem -.5rem;
}
.opcBusqueda {
    padding: .5rem .5rem;
    margin: -.5rem 1.5rem -.5rem auto;
}
.el-del-medio {
   
   margin-left: auto;
   margin-right: auto;
   
}
.hgt-del-medio {
   height: 40px;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-15 {
   font-size: 15px;
}
.cntt-resu {
   width: 210px;
}
.bg-thead {
   background-color: blueviolet;
}
.ws-nowrap {
   white-space: nowrap;
}
.all-data {
   background-color: rgba(0, 0, 0, .75);
   height: 100%;
   width: 100%;
   position: absolute; 
   top:0;
   left:0
}
.aff-data {
   color: white;
}
</style>